// @ts-check

/**
 * @typedef {(data: any | undefined) => void} SubscribeCallback
 * @typedef {object} SubscribeOptions
 * @property {boolean} unsubscribePrevious Remove previous subscription.
 */

/** @type {Map<string, SubscribeCallback[]>} */
const eventSubscribers = new Map();

/**
 * Publish event.
 *
 * @param {string} eventName
 * @param {*} [data]
 */
export function publish(eventName, data) {
  if (!eventSubscribers.has(eventName)) {
    return;
  }

  eventSubscribers.get(eventName).forEach((callback) => {
    callback(data);
  });
}

/**
 * Unsubscribe from event publications.
 *
 * @param {string} eventName
 * @param {SubscribeCallback} callback The same function that was passed to `subscribe` method.
 */
export function unsubscribe(eventName, callback) {
  if (!eventSubscribers.has(eventName)) {
    return;
  }

  const subscriptionIndex = eventSubscribers.get(eventName).findIndex((savedCallback) => savedCallback === callback);

  if (subscriptionIndex !== -1) {
    eventSubscribers.get(eventName).splice(subscriptionIndex);
  }
}

/**
 * Subscribe to event publications.
 *
 * @param {string} eventName
 * @param {SubscribeCallback} callback
 * @param {SubscribeOptions} [options]
 * @returns {{ unsubscribe: () => void }} Subscription object.
 */
export function subscribe(eventName, callback, options) {
  if (!eventSubscribers.has(eventName)) {
    eventSubscribers.set(eventName, []);
  }

  if (options && options.unsubscribePrevious) {
    unsubscribe(eventName, callback);
  }

  eventSubscribers.get(eventName).push(callback);

  return {
    unsubscribe() {
      unsubscribe(eventName, callback);
    }
  };
}
